import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanLoad,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
    UrlTree,
} from '@angular/router';
import { RmmHierarchyAccessService } from '../services/rmm-hierarchy-access.service';

/**
 * Enforces org-level RMM hierarchy access (US: SIICA/SECL HQ, SBS HQ, SBS Branch, Dealer HQ, Division;
 * EU: SSA, SA, DA). Role-based tenant access remains in PERMISSION_GUARD.
 */
@Injectable()
export class RmmHierarchyGuard implements CanActivate, CanActivateChild, CanLoad {

    constructor(
        private hierarchyAccessService: RmmHierarchyAccessService,
        private router: Router,
    ) {}

    canLoad(_route: Route, _segments: UrlSegment[]): boolean | UrlTree {
        return this.evaluate(this.router.url);
    }

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.evaluate(state.url);
    }

    canActivateChild(
        _childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): boolean | UrlTree {
        return this.evaluate(state.url);
    }

    private evaluate(url: string): boolean | UrlTree {
        if (!url?.includes('/rmm')) {
            return true;
        }

        // Bypassing RMM Hierarchy guard for EKM users to allow the routes navigatable via the sidebar
        const isEkmUserAllowed = this.hierarchyAccessService.evaluateEkmUserAccess(url);
        if (isEkmUserAllowed) {
            return true;
        }

        const result = this.hierarchyAccessService.evaluateAccess(url);
        if (result.allowed) {
            return true;
        }

        return this.router.parseUrl(result.redirectUrl);
    }
}
